var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer modulewrap"},[_c('div',{staticClass:"copyright realwrap",domProps:{"innerHTML":_vm._s(_vm.$common.langinfo(_vm.footerinfo.content,_vm.footerinfo.content_en).replace('@@','&copy;'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }